/**
 * Chakra-headers (§4 van de build-spec): theming-tokens + spelerwaarden (§1.5).
 *
 * maxHP = 50 voor elke chakra. maxEnergie: ch1–3 = 3, ch4–6 = 4, ch7 = 5.
 * Bloemblaadjes voor ch7 zijn symbolisch ~1000 → gerenderd als dichte ring van
 * 32 stippen (waarde 32 hieronder).
 */
import type { ChakraHeader, Origin } from './types';

export const HEADERS: Record<Origin, ChakraHeader> = {
  1: {
    nummer: 1,
    naam: 'Muladhara',
    sanskriet: 'मूलाधार',
    element: 'Aarde',
    kleur: '#b3202c',
    accent: '#c9a86a',
    mantra: 'LAM',
    freq: 396,
    resourceLabel: 'Stabiliteit',
    bloemblaadjes: 4,
    maxHP: 50,
    maxEnergie: 3,
  },
  2: {
    nummer: 2,
    naam: 'Svadhisthana',
    sanskriet: 'स्वाधिष्ठान',
    element: 'Water',
    kleur: '#c1612b',
    accent: '#1c3a5e',
    mantra: 'VAM',
    freq: 417,
    resourceLabel: 'Flow',
    bloemblaadjes: 6,
    maxHP: 50,
    maxEnergie: 3,
  },
  3: {
    nummer: 3,
    naam: 'Manipura',
    sanskriet: 'मणिपूर',
    element: 'Vuur',
    kleur: '#d9a428',
    accent: '#2b2b28',
    mantra: 'RAM',
    freq: 528,
    resourceLabel: 'Wilskracht',
    bloemblaadjes: 10,
    maxHP: 50,
    maxEnergie: 3,
  },
  4: {
    nummer: 4,
    naam: 'Anahata',
    sanskriet: 'अनाहत',
    element: 'Lucht',
    kleur: '#2f6f4f',
    accent: '#c98a7a',
    mantra: 'YAM',
    freq: 639,
    resourceLabel: 'Hartenergie',
    bloemblaadjes: 12,
    maxHP: 50,
    maxEnergie: 4,
  },
  5: {
    nummer: 5,
    naam: 'Vishuddha',
    sanskriet: 'विशुद्ध',
    element: 'Ether',
    kleur: '#1f6f8b',
    accent: '#c9c9d4',
    mantra: 'HAM',
    freq: 741,
    resourceLabel: 'Stemkracht',
    bloemblaadjes: 16,
    maxHP: 50,
    maxEnergie: 4,
  },
  6: {
    nummer: 6,
    naam: 'Ajna',
    sanskriet: 'आज्ञा',
    element: 'Licht',
    kleur: '#4b3f72',
    accent: '#b9aee0',
    mantra: 'OM',
    freq: 852,
    resourceLabel: 'Helderheid',
    bloemblaadjes: 2,
    maxHP: 50,
    maxEnergie: 4,
  },
  7: {
    nummer: 7,
    naam: 'Sahasrara',
    sanskriet: 'सहस्रार',
    element: 'Bewustzijn',
    kleur: '#6e3fa3',
    accent: '#e8d9a0',
    mantra: 'AUM',
    freq: 963,
    resourceLabel: 'Verbinding',
    bloemblaadjes: 32,
    maxHP: 50,
    maxEnergie: 5,
  },
};

/** Alle 7 mantra-frequenties (voor de audio-eindfinale, §13/§18). */
export const ALLE_FREQUENTIES = [396, 417, 528, 639, 741, 852, 963];
